import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enCommon from './locales/en/common.json';
import etCommon from './locales/et/common.json';

const resources = {
  en: {
    translation: enCommon,
  },
  et: {
    translation: etCommon,
  },
};

// Custom language detection function
const detectLanguage = (): string => {
  // First check URL path
  const pathLang = window.location.pathname.split('/')[1];
  if (pathLang === 'en' || pathLang === 'et') {
    return pathLang;
  }

  // Check localStorage
  const storedLang = localStorage.getItem('i18nextLng');
  if (storedLang === 'en' || storedLang === 'et') {
    return storedLang;
  }

  // Check browser language
  const browserLang = navigator.language || (navigator as any).userLanguage;
  
  // If browser language is Estonian, use Estonian
  if (browserLang.startsWith('et')) {
    return 'et';
  }
  
  // If browser language is English, use English
  if (browserLang.startsWith('en')) {
    return 'en';
  }
  
  // Default to English for all other languages
  return 'en';
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    lng: detectLanguage(), // use custom detection
    fallbackLng: 'en', // fallback language
    debug: process.env.NODE_ENV === 'development',
    
    // Custom language detection options
    detection: {
      order: ['path', 'localStorage', 'navigator', 'htmlTag'],
      lookupFromPathIndex: 0,
    },

    interpolation: {
      escapeValue: false, // React already does escaping
    },

    // Use translation as default namespace
    defaultNS: 'translation',
    ns: ['translation'],
  });

export default i18n;
